export const UserAndRoleConst = {
    userAPI: 'api/User',
    getAllUserDetailsByEmail: '/GetAllUserDetailsByEmail',
    getProfileInfo: '/GetUserDetails',
    saveProfileInfo: '/UpdateUserDetails',
}

export const UserInfo = {
    routePath: 'userInfo',
}